import React from 'react';
import { useHistory } from 'react-router';

import PartnersImg from 'products/global/assets/img/birds/partners.png';

import { H3, H4, H5, Link, A, P } from 'components/Typography';
import FadeInImage from 'components/FadeInImage';
import EarningsTable from '../../components/EarningsTable';
import Wave from './components/Wave';

import PARTNERS from './partners';

import {
  PartnersContainer,
  Bird,
  Content,
  Line,
  Partner,
  PartnerLink,
  PartnerImage,
  PartnersGrid,
  PartnerText,
  Intro,
  IntroText,
  Image,
  StyledButton
} from './styled';

const Partners = () => {
  const history = useHistory();

  return (
    <>
      <Wave />
      <PartnersContainer bg="white">
        <Bird>
          <FadeInImage src={PartnersImg} alt="two birds with a gift" />
        </Bird>

        <Content>
          <H3>Become a SafetyWing Partner!</H3>
          <Intro>
            <IntroText>
              <P>
                Our partners are a variety of digital and physical businesses, such as
                travel websites, bloggers, influencers, co-working spaces, remote work
                retreats, online communities, tech companies, conferences, magazines,
                podcasts, apps, and many more! If you don’t fit any of the categories
                above, but think you’re a good fit to promote SafetyWing, please keep
                reading!
              </P>
              <P>
                We provide materials to help you with the promotion, including a product
                overview, logos, photos, and a price widget, which can easily be embedded
                on any website.
              </P>
              <P>
                To become our partner, you can either join the ambassador program or
                contact us.
              </P>
            </IntroText>
            <Image src={PartnersImg} alt="two birds with a gift" />
          </Intro>
          <H4>SafetyWing Ambassador Program</H4>
          <P>
            The Ambassador Program is the easiest way to partner with us. As a SafetyWing
            Ambassador, you have access to a self-service tool and earn a fee by
            introducing new people to SafetyWing. It's a win-win solution with no cost or
            investment required.
          </P>
          <StyledButton onClick={() => history.push('/ambassador/signup')}>
            Apply here
          </StyledButton>

          <H5>How does the ambassador program work?</H5>
          <P>
            All purchases made by a referred user will earn you an ambassador fee for the
            first 364 days after sign-up. Likewise, if someone you refer subscribes
            repeatedly to cover several shorter trips or different products, you will earn
            a fee every month for that member. Referral Fees within the 1-year time period
            per new user:
          </P>
          <Link to="/nomad-insurance">
            <b>Nomad Insurance</b>
          </Link>
          <P>
            10% of the value of consumed purchases (around $50 per user with a year-long
            contract). This product is available to purchase with auto-extension so that
            it works like a subscription. It can be canceled at any time. It is also
            possible to pay upfront for a trip as short as 5 days or as long as 364 days.
          </P>
          <P>Here are some examples of how they would compare:</P>
          <EarningsTable />

          <P>
            We issue payouts once a month via PayPal when you reach a minimum threshold of
            $10. You will get access to a dashboard that allows you to log in and see the
            number of registrations and sales daily.{' '}
          </P>
          <P>
            Any questions? Visit the Ambassador Program{' '}
            <A href="https://www.notion.so/safetywing/Ambassador-Program-Frequently-Asked-Questions-4ae460934c9a4628afb6496bedb9dca2">
              frequently asked questions
            </A>
            .
          </P>

          <H4>Contact us</H4>
          <P>
            Email{' '}
            <A href="mailto:partnerships@safetywing.com">partnerships@safetywing.com</A>{' '}
            with your detailed proposal if you are interested in a more complex
            integration (like an API) or from a media, brand or another perspective not
            covered in our Ambassador program and your reachable audience is larger than
            50,000 users or your business generates more than $500,000/year.
          </P>

          <Line />

          <H3>Our partners</H3>
          <p>
            We partner with hundreds of companies, websites and influencers. Some of them
            are:
          </p>

          <PartnersGrid>
            {PARTNERS.map((partner) => (
              <Partner key={partner.name}>
                <PartnerLink href={partner.website}>
                  <PartnerImage src={partner.logo} alt="partner logo" />
                </PartnerLink>
                <PartnerText>{partner.description}</PartnerText>
              </Partner>
            ))}
          </PartnersGrid>
        </Content>
      </PartnersContainer>
    </>
  );
};

export default Partners;
